import React from "react";
import ResourceAdmin from "../../components/admin/ResourceAdmin";
import { adminApi } from "../../lib/api";

export default function LigasAdmin() {
  return (
    <ResourceAdmin
      title="Ligas"
      subtitle="Niveles competitivos de gamificación por puntos."
      resource={adminApi.resource("ligas")}
      defaults={{ nombre: "", nivel: 1, puntos_min: 0, color: "#F5C518", icono: "Trophy" }}
      fields={[
        { name: "nombre", label: "Nombre", type: "text", placeholder: "Ej. Liga Oro" },
        { name: "nivel", label: "Nivel", type: "number" },
        { name: "puntos_min", label: "Puntos mínimos", type: "number" },
        { name: "color", label: "Color (hex)", type: "text", placeholder: "#F5C518" },
        { name: "icono", label: "Icono (lucide)", type: "text", placeholder: "Trophy" },
      ]}
      columns={[
        { name: "nivel", label: "Nivel" },
        { name: "nombre", label: "Liga", render: (i) => (
          <span className="inline-flex items-center gap-2 font-bold text-[#0A1C30]">
            <span className="w-3.5 h-3.5 rounded-full" style={{ background: i.color }} /> {i.nombre}
          </span>
        ) },
        { name: "puntos_min", label: "Puntos mín.", render: (i) => `${i.puntos_min} pts` },
        { name: "icono", label: "Icono" },
      ]}
    />
  );
}
